import { defineMessages } from 'react-intl';

export default defineMessages({
  totalPrice: {
    id: 'Pdp.AovFooter.totalPrice',
    description: 'Total Price Text',
    defaultMessage: 'Total Price',
  },
  continueToCart: {
    id: 'Pdp.AovFooter.button.continueToCart',
    description: 'Continue to cart footer message',
    defaultMessage: 'No Thanks, Continue to Cart',
  },
  addToCart: {
    id: 'Pdp.AovFooter.addToCart',
    description: 'Add to cart footer message',
    defaultMessage: `{count, plural,
      one {Add Item to Cart}
      other {Add Items to Cart}
    }`,
  },
  pricingSubtotalFinanceLegend: {
    id: 'Pdp.AovFooter.financing.legend',
    defaultMessage: 'Pay as low as',
  },
  errorAddingItems: {
    id: 'Pdp.AovFooter.errorAddingItems',
    defaultMessage: 'Something went wrong, please try again.',
  },
  itemsSelected: {
    id: 'Pdp.AovFooter.itemsSelected',
    defaultMessage: 'Items Selected',
  },
});
